import React from "react";
import Login_Comp from "../../../components/pages/auth/login";

const Login: React.FC = () => {
  return <Login_Comp />;
};

export default Login;
